<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-action-alert controlName="totalSolids" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
            <app-unit-quantity label="Total Solids" unitLabel="g/L" placeholder="Value" inputMode="numeric" formControlName="totalSolids"></app-unit-quantity>
            <app-select label="Plasma Colour" placeholder="Choose..." [items]="plasmaColour" [saveValue]="true" formControlName="plasmaColour"></app-select>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
    </div>
</app-action-form>
